exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-control[data-v-1fde0595] {\n  width: auto;\n  float: right;\n}\n.feedback-text[data-v-1fde0595] {\n  margin-top: 20px;\n}\n.on-moder[data-v-1fde0595] {\n  background-color: #c9e9ff !important;\n}\n.shadowed[data-v-1fde0595]:hover {\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);\n  transition: all 0.25s ease;\n}\n.sort-by[data-v-1fde0595] {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n}\n.sort-by .title[data-v-1fde0595] {\n  align-self: center;\n  padding-right: 10px;\n}", ""]);

// exports
